import { z } from 'zod'

export const interviewTypes = ['phone', 'video', 'onsite', 'technical', 'behavioral'] as const
export const interviewStatuses = ['scheduled', 'completed', 'cancelled', 'no_show'] as const

export const createInterviewSchema = z.object({
  applicationId: z.string().min(1, 'Application ID is required'),
  title: z.string().min(1).max(200),
  type: z.enum(interviewTypes).default('video'),
  scheduledAt: z.number().int().positive('Scheduled time is required'),
  durationMinutes: z.number().int().min(15).max(480).default(60),
  timezone: z.string().default('UTC'),
  location: z.string().max(500).optional(),
  videoLink: z.string().url().optional().or(z.literal('')),
  notes: z.string().max(5000).optional(),
  participantIds: z.array(z.string()).min(1, 'At least one participant is required'),
})

export const updateInterviewSchema = createInterviewSchema.partial().omit({ applicationId: true }).extend({
  status: z.enum(interviewStatuses).optional(),
})

export const interviewFiltersSchema = z.object({
  applicationId: z.string().optional(),
  status: z.enum(interviewStatuses).optional(),
  fromDate: z.coerce.number().optional(),
  toDate: z.coerce.number().optional(),
})

export const updateParticipantResponseSchema = z.object({
  response: z.enum(['accepted', 'declined', 'tentative']),
})

export type CreateInterviewInput = z.infer<typeof createInterviewSchema>
export type UpdateInterviewInput = z.infer<typeof updateInterviewSchema>
export type InterviewFiltersInput = z.infer<typeof interviewFiltersSchema>
export type UpdateParticipantResponseInput = z.infer<typeof updateParticipantResponseSchema>
